import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { linkedInConnect } from '../services/api';
import { useAuth } from '../context/AuthContext';

const LinkedInCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const storedState = sessionStorage.getItem('linkedin_state');

    if (!code) {
      setError('LinkedIn ile giriş başarısız.');
      return;
    }

    if (state && storedState && state !== storedState) {
      setError('Güvenlik doğrulaması başarısız.');
      return;
    }

    sessionStorage.removeItem('linkedin_state');

    // LinkedIn redirect flow: code'u BE'ye gönder, BE access_token alır
    linkedInConnect(code)
      .then((result) => {
        if (result.status && result.data?.token) {
          login(result.data);
          navigate(result.data.candidateId ? '/' : '/panel/profil', { replace: true });
        } else {
          setError(result.message || 'LinkedIn ile giriş başarısız.');
        }
      })
      .catch(() => {
        setError('LinkedIn ile giriş başarısız. Lütfen tekrar deneyin.');
      });
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '16px' }}>
        <p style={{ color: '#DC2626', fontSize: '15px' }}>{error}</p>
        <button
          onClick={() => navigate('/', { replace: true })}
          style={{ padding: '10px 24px', borderRadius: '9999px', background: '#2F3A8F', color: '#fff', border: 'none', cursor: 'pointer', fontSize: '14px' }}
        >
          Ana Sayfaya Dön
        </button>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <p style={{ color: '#475569', fontSize: '15px' }}>Giriş yapılıyor...</p>
    </div>
  );
};

export default LinkedInCallbackPage;
